import { Box, TextField, Typography } from "@mui/material";

interface PromptTextFieldProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const PromptTextField = ({ label, placeholder, value, onChange, disabled = false }: PromptTextFieldProps) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {label}
      </Typography>
      <TextField
        fullWidth
        multiline
        minRows={4}
        maxRows={12}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        sx={{
          "& .MuiOutlinedInput-root": {
            fontFamily: "monospace",
            fontSize: "0.875rem"
          }
        }}
      />
    </Box>
  );
};

export default PromptTextField;
